{
  "loading": "Chargement...",
  "placeholder": "Sélectionnez une option..."
}